import ViewSalesOrder from "../../../../components/@documents/sales_orders/ViewSalesOrder";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function SalesOrdersPage() {

    return (
        <ViewSalesOrder 
            routeType={routeTypes.retail}
        />
    )
}